import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { CalendarDay } from '../../lib/calendar-day';
import { CalendarState } from '../../lib/calendar-state';
import { PgCalendarCursorComponent } from '../../pg-calendar-cursor/pg-calendar-cursor.component';

@Component({
  selector: 'pg-calendar-date-grid, grit-calendar-date-grid',
  templateUrl: './pg-calendar-date-grid.component.html',
  styleUrls: ['./pg-calendar-date-grid.component.scss'],
  exportAs: 'gritCalendarDateGrid',
})
export class PgCalendarDateGridComponent
  implements OnInit, AfterViewInit, OnChanges {
  @Input()
  displayDate: Date;

  cellSize: number;
  gridWidth: number;

  @Input()
  selectedDate: Date;

  @ViewChild('gridWrapper', { static: true })
  _gridWrapperChild: ElementRef;

  @Input()
  monthArray: CalendarDay[];

  @Output()
  dateSelected = new EventEmitter<CalendarDay>();

  @ViewChild('cursor', { static: true })
  cursor: PgCalendarCursorComponent;

  get gridWrapperEl(): HTMLElement {
    return this._gridWrapperChild.nativeElement;
  }

  constructor(
    public elementRef: ElementRef,
    private _cdRef: ChangeDetectorRef,
    public calendarState: CalendarState
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.displayDate) {
      // TODO:
    }
  }

  ngAfterViewInit() {
    this.calculateGridDimensions();

    this.calendarState.selectedDate.subscribe(date => {
      this.placeCursorOverSelectedDate(date);
      this.selectedDate = date;
    });

    this._cdRef.detectChanges();
  }

  public calculateGridDimensions() {
    this.gridWidth = this.gridWrapperEl.clientWidth;
    this.cellSize = Math.floor(this.gridWidth / 7);
  }

  public placeCursorOverSelectedDate(date, resizeOnly = false) {
    if (!date) {
      return;
    }

    let selectedIndex = -1;
    let selectedDay = null;
    this.monthArray.forEach((day: CalendarDay, i: number) => {
      if (this.dateCompare(day.date, date)) {
        selectedIndex = i;
        selectedDay = day;
      }
    });

    if (selectedDay && selectedIndex > -1) {
      const gridX = selectedIndex % 7;
      const gridY = Math.floor(selectedIndex / 7);

      const projectedX = this.cellSize * gridX;
      const projectedY = this.cellSize * gridY;
      if (resizeOnly) {
        this.cursor.setPosition(projectedX, projectedY);
      } else {
        this.cursor.setPosition(projectedX, projectedY).then(() => {
          return this.cursor.show();
        });
      }
    } else {
      this.cursor.hide();
    }
  }

  handleCellKeydown($event: KeyboardEvent, day) {
    if ($event.keyCode === 13) {
      this.handleCellClicked(day);
    }
  }

  @HostListener('window:resize')
  windowResize() {
    this.calculateGridDimensions();
    this.placeCursorOverSelectedDate(this.selectedDate, true);
  }

  /**
   * javascriptMonth is -1 from the semantic month
   * e.g. January = 0
   */
  showCalendarMonth(
    javascriptMonth: number,
    year: number,
    options: { direction: 'forward' | 'backward' }
  ) {}

  handleCellClicked(day: CalendarDay) {
    if (day.outOfRange) {
      return;
    }
    this.dateSelected.emit(day);
    // this.calendarState.selectedDate.next(day.date);
  }

  dateCompare(d1: Date, d2: Date) {
    if (!d1 || !d2) {
      return false;
    }
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }

  isToday(d: Date) {
    const today = new Date();
    return (
      d.getFullYear() === today.getFullYear() &&
      d.getMonth() === today.getMonth() &&
      d.getDate() === today.getDate()
    );
  }
}
